export const NOTIFICATION_TIMEOUT = 5000;

export const CONTEXT_POLLING_INTERVAL = 60000;

export const DEFAULT_THEME = 'DEFAULT';
